<div class="n-phone-number-row" [formGroup]="formGroup">
    <mat-form-field appearance="outline" class="n-flex-field">
        <mat-label>Phone number</mat-label>
        <mat-icon matPrefix>phone</mat-icon>
        <input matInput formControlName="rawNumber">
    </mat-form-field>
</div>
